export default __webpack_public_path__ + "static/media/monaco-team-offer-top.de9aca4a.png";